import React from 'react';

const VisibleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M11.5 5.706c4.142 0 7.5 4.662 7.5 5.625 0 .963-3.358 5.625-7.5 5.625-4.142 0-7.5-4.632-7.5-5.625 0-.993 3.358-5.625 7.5-5.625zm0 1.875a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm0 1.875a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75z" />
  </svg>
);

export default VisibleIcon;
